module.exports = __webpack_public_path__ + "media/images/favicon/favicon-16x16-50ea1e6ec11d06112bda44da10dc107f.png";